import { getCustomerDataByNik, getStatusBulkBatchBlockUnblock, requestFileDocumentSupport, updateNikStatus, updateNikStatusBulk } from '../../utils/api';
import { triggerDownload } from '../../utils/hooks';
import { SEARCH_FAILED, SEARCH_LOADING, SEARCH_SUCCESS } from './constants';

export function setFailedAction({ key, data, message, error, code, status }) {
  return { type: SEARCH_FAILED, key, data, message, error, code, status };
}

export function setLoadingAction({ key, isLoading = true }) {
  return { type: SEARCH_LOADING, key, isLoading };
}

export function setSuccessAction({ key, data, code, message, success, status }) {
  return { type: SEARCH_SUCCESS, key, data, code, message, success, status };
}

export const clearRedux = (key) => {
  return async (dispatch) => {
    // const key = 'dataNikManagement';
    dispatch(setLoadingAction({ key, isLoading: false }));
    dispatch(setSuccessAction({ key, data: null, code: null, message: '', success: false }));
    dispatch(setFailedAction({ key, message: '', error: null, code: null }));
  };
};

export function fetchSearchNik(nationalityId, isMasked = true) {
  return async (dispatch) => {
    const key = 'dataNikManagement';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } = await getCustomerDataByNik(nationalityId, isMasked);
      data.nationalityIdPlan = nationalityId;
      dispatch(setSuccessAction({ key, data, code, message, status }));
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data, message: error?.message,
        code: error?.code || null, error
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}

export function actionUpdateNikStatus(payload) {
  return async (dispatch) => {
    const key = 'updateNikStatus';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } = await updateNikStatus(payload);
      dispatch(setSuccessAction({ key, data, code, message, status }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    } catch (error) {
      dispatch(setFailedAction({ key, message: error?.message, code: error?.code || null, error }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}

export function actionUpdateNikStatusBulk(payload, callback = () => { }) {
  return async (dispatch) => {
    const key = 'updateNikStatusBulk';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } = await updateNikStatusBulk(payload);
      dispatch(setSuccessAction({ key, data, code, message, status }));
      dispatch(setLoadingAction({ key, isLoading: false }));
      callback({
        success: true,
        data
      });
    } catch (error) {
      dispatch(setFailedAction({
        key, data: error.data, message: error?.message,
        code: error?.code || null, error, status: error?.status || null
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
      callback({
        data: error.data, message: error?.message,
        code: error?.code || null, error, status: error?.status || null
      });
    }
  };
}

export function fetchCheckStatusBulk(requestId) {
  return async (dispatch) => {
    const key = 'dataCheckStatusBulk';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } =
        await getStatusBulkBatchBlockUnblock(requestId);
      dispatch(setSuccessAction({ key, data, code, message, status }));
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data, message: error?.message,
        code: error?.code || null, error
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}

export function fetchListRequestStatusBulk(params) {
  return async (dispatch) => {
    const key = 'listRequestStatusBulk';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } =
        await getStatusBulkBatchBlockUnblock('', params);
      dispatch(setSuccessAction({ key, data, code, message, status }));
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data, message: error?.message,
        code: error?.code || null, error
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}

export function fetchRequestSummaryFile(params, callback = () => { }) {
  return async (dispatch) => {
    const key = 'requestSummaryFile';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } =
        await requestFileDocumentSupport(params);
      dispatch(setSuccessAction({ key, data, code, message, status }));
      callback({ success: true });
      triggerDownload(data?.url, 'summary_bulk_status.csv');
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data, message: error?.message,
        code: error?.code || null, error
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
      callback({ success: false });
    }
  };
}

export function fetchStatusBlockUnblock(id) {
  return async (dispatch, getState) => {
    const key = 'listRequestStatusBulk';
    const { listRequestStatusBulk } = getState().nikManagement;
    const listProcesses = listRequestStatusBulk.data;
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      // const data = {
      //   id: 'dcb0136c-5d5d-43b4-b6fd-c09eac861cb6',
      //   status: 'DONE',
      //   totalSuccess: 1
      // };
      const { data } = await getStatusBulkBatchBlockUnblock(id);
      const newList = listProcesses.map(item =>
        item.id === data.id ? { ...item, ...data } : item
      );
      dispatch(setSuccessAction({ key, ...listRequestStatusBulk, data: newList }));
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data, message: error?.message,
        code: error?.code || null, error
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}
